// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/confirm\",\"regex\":\"^/([^/]+)/confirm$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/sentry\",\"regex\":\"^/([^/]+)/sentry$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/studio/:tool*?\",\"regex\":\"^/studio(?:/(.*))?$\",\"paramNames\":[\"tool\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://6b7db5d77ec1f7f827cc224dc9de4350@o4505510382469120.ingest.us.sentry.io/4511144811102208',

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
